import axios from 'axios';

const api = axios.create({
	baseURL: import.meta.env.VITE_BASE_URL,
	headers: {
		Accept: 'application/json,multipart/form-data',
		'Content-Type': 'application/json',
	},
});

export default api;
